module Omni.Booker {
    NgModule.component("omniBookerSpecialRates", {
        bindings: {
            propertyDetail: "=",
            rateInformation: "="
        },
        controller: class SpecialRatesController {
            private expandRates: boolean; 
            private rateInformation: RateCodes;
            private propertyDetail: PropertyDetail;
            private isUserSignedIn: boolean;
            private userFreeNights: number;
            private displayExpedia: boolean;

            private modalInstanceDeferred;  // Makes sure we only have one instance of a modal open at a time.
            private signInModalInstanceDeferred; // Make sure we only have one instance of sign in modal open at a time.
            private profileDeferred;

            static $inject = ["$log", "$uibModal", "$q", "omni.core.profileservice", "omni.bookingservice", "bookerConfig"];
            constructor(
                private $log: ng.ILogService,
                private $uibModal,
                private $q: ng.IQService,
                private profileService: Core.IProfileService,
                private bookingService: Booker.IBookingService,
                private readonly bookerConfig: Constants.IBookerConfiguration) {
                this.expandRates = false;
                this.displayExpedia = this.bookerConfig.ShowExpediaLink;
            }
             
            public $onInit() {
                this.$log.debug("rateInfo=", this.rateInformation);
                
            }

            public rateCodeInterpreter = (value) => {
                if (value) {
                    var old = this.rateInformation.RateCode;
                    this.rateInformation.RateCode = value;
                   
                    this.openComponentModal().then((response) => {
                       
                        if (response === "ok") {
                            this.rateInformation.GroupCode = "";
                            this.rateInformation.PromoCode = "";
                            this.rateInformation.RateCode = value;
                        } else {
                            this.rateInformation.RateCode = old;
                        }
                    }).finally(() => {
                        this.syncToService();
                    });
                   
                } else {
                    return this.rateInformation.RateCode;
                }
            }

            public groupCodeInterpreter = (value) => {
                if (typeof value != "undefined") {
                    // If group is already selected, we can continue to receive input
                    if (this.rateInformation.RateCode === "group_code") {
                        this.rateInformation.GroupCode = value;
                        this.syncToService();
                        return this.rateInformation.GroupCode;
                    }

                    var old = this.rateInformation.GroupCode;

                    this.openComponentModal().then((response) => {
                        if (response === "ok") {
                            this.rateInformation.RateCode = "group_code";
                            this.rateInformation.PromoCode = "";
                            this.rateInformation.GroupCode = value;
                        } else {
                            this.rateInformation.GroupCode = old;
                        }
                    }).finally(() => {
                        this.syncToService();
                    });
                } else {
                    return this.rateInformation.GroupCode;
                }
            }

            public promoCodeInterpreter = (value) => {
                if (typeof value != "undefined") {
                    // If promo is already selected, we can continue to receive input
                    if (this.rateInformation.RateCode === "promotional_code") {
                        this.rateInformation.PromoCode = value;
                        this.syncToService();
                        return this.rateInformation.PromoCode;
                    }

                    var old = this.rateInformation.PromoCode;
                    this.openComponentModal().then((response) => {
                        if (response === "ok") {
                            this.rateInformation.RateCode = "promotional_code";
                            this.rateInformation.GroupCode = "";
                            this.rateInformation.PromoCode = value;
                        } else {
                            this.rateInformation.PromoCode = old;
                        }
                    }).finally(() => {
                        this.syncToService();
                    });
                } else {
                    return this.rateInformation.PromoCode;
                }
            }

            public freeNightsInterpreter = (value) => {
                if (typeof(value) !== "undefined") {
                    // Capture old value, set new value immediately
                    var old = this.rateInformation.IsRedeemingFreeNights;
                    this.rateInformation.IsRedeemingFreeNights = value;

                    // Request user profile, ensure user is signed in
                    this.getUserProfile().then(() => {
                        if (this.isUserSignedIn) {
                            // already signed in
                            this.syncToService();
                        } else {
                            this.openSignInModal().then((response) => {
                                if (response === "ok") {
                                    // user will be signed in (and redirected) to SSL site, we will never receive the sign in action here
                                } else {
                                    // user cancelled, reset redeeming nights value
                                    this.rateInformation.IsRedeemingFreeNights = old;
                                    this.syncToService();
                                }
                            });
                        }
                    });
                } else {
                    return this.rateInformation.IsRedeemingFreeNights;
                }
            }

            private openComponentModal = () => {
                if (this.modalInstanceDeferred) {
                    return this.modalInstanceDeferred;
                }

                var deferred = this.$q.defer();
                var promoDefined = false, groupDefined = false;
              
                if (angular.isDefined(this.rateInformation.PromoCode) && this.rateInformation.PromoCode.length > 0) {
                    promoDefined = true;
                        
                }
              
                if (angular.isDefined(this.rateInformation.GroupCode) && this.rateInformation.GroupCode.length > 0) {
                    groupDefined = true;
                }
               
                if (!promoDefined && !groupDefined) {
                    deferred.resolve("ok");
                    return deferred.promise;
                }
                
                var modalInstance = this.$uibModal.open({
                    animation: true,
                    component: 'rateConfirmModal',
                    resolve: {

                    }
                });

                modalInstance.result.then((selectedItem) => {
                    this.$log.debug('modal-component ok\'ed at: ' + new Date());
                    deferred.resolve("ok");
                }, () => {
                    this.$log.debug('modal-component dismissed at: ' + new Date());
                    deferred.resolve("cancel");
                }).finally(() => { 
                    this.modalInstanceDeferred = undefined;  
                });

                this.modalInstanceDeferred = deferred.promise;
                return this.modalInstanceDeferred;
            };

            private openSignInModal = () => {
                if (this.signInModalInstanceDeferred) {
                    return this.signInModalInstanceDeferred;
                }

                var deferred = this.$q.defer();

                var modalInstance = this.$uibModal.open({
                    animation: true,
                    component: 'signInModal',
                    ariaLabelledBy: 'sign-in-modal-title',
                    resolve: {

                    }
                });

                modalInstance.result.then((selectedItem) => {
                    this.$log.debug('signin-component ok\'ed at: ' + new Date());
                    deferred.resolve("ok");
                }, () => {
                    this.$log.debug('signin-component dismissed at: ' + new Date());
                    deferred.resolve("cancel");
                }).finally(() => {
                    this.signInModalInstanceDeferred = undefined;
                });

                this.signInModalInstanceDeferred = deferred.promise;
                return this.signInModalInstanceDeferred;
            }

            private getUserProfile = () => {
                if (this.profileDeferred) {
                    return this.profileDeferred;
                }

                this.profileDeferred = this.profileService.GetProfile();
                this.profileDeferred.then((profileRes) => {
                    this.isUserSignedIn = profileRes.IsUserLoggedIn === "true";
                    this.userFreeNights = parseInt(profileRes.FreeNights, 10);
                });

                return this.profileDeferred;
            }

            private syncToService() {
                this.bookingService.PutRateCodes(this.rateInformation);
            }

            public onPromoCodeClick() {
                document.getElementById("promoCode").focus();              
            }

            public onGroupCodeClick() {
                document.getElementById("groupCode").focus();
            }

        },
        templateUrl: "omni-booker-special-rates.html"
    });  
}  
